var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.notes[0])?_c('div',[_c('span',{staticClass:"flix-bg-warning"},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.$nl2br(_vm.notes[0].msg))}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }